<template>
  <div :class="[`sidebar`, `sidebar--contentful`, `sidebar--${currentRouteName}`]">
    <div class="group group--df-column">
      <h1 
        v-if="!tree.length" 
        :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
        class="h1">{{ title }}</h1>
      <p v-if="!tree.length" class="p">Life can be hard sometimes. Here you can find support for a variety of challenges we all encounter in life.</p>

      <ul v-if="tree.length" class="breadcrumbs">
        <li class="breadcrumbs__item breadcrumbs__item--first">
          <router-link 
            :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
            class="" 
            :to="{ name: 'topics' }">All topics</router-link>
        </li>

        <li
          v-for="link in tree"
          :key="link.name"
          :class="[`breadcrumbs__item`, $route.name === link.name ? `disabled` : ``]"
        >
          <a 
            :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
            @click="navigateTo(link)">{{ link.title }}</a>
        </li>
      </ul>

      <ul v-if="!tree.length" class="sidebar__nav fs0 mt">
        <li
          v-for="category in categoriesToShow"
          :key="category.id"
          @click="scrollToSection(category.slug)"
          :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
          :class="[
            `sidebar__nav--item`,
            activeSection === category.slug ? 'fw-bold sidebar__nav--item-active' : '',
          ]"
        >
          {{ category.name }}
        </li>
      </ul>

      <!-- <img
        class="sidebar__image"
        v-if="topic && topic.sidebarImage"
        :src="sidebarImage.url"
        :title="sidebarImage.title"
        :alt="sidebarImage.title"
      > -->
    </div>

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

// Utils
import { toSlug } from 'utils/string';

export default {
  name: 'ui-article-sidebar',

  // Computed
  computed: {
    ...mapGetters('contentful', ['categories']),
    ...mapGetters('contentful', ['topics', 'articles']),
    ...mapGetters('app', ['org']),
    ...mapGetters('sidebar', ['activeSection', 'defaultOffset']),

    topic() {
      if ( !this.topics || !this.topics.length ) return;
      return _.find(this.topics, topic => topic.id === this.$route.query.topicId); // eslint-disable-line
    },

    categoriesToShow() {
      return _.map(this.categories, category => { // eslint-disable-line no-undef
        category.slug = toSlug(category.name);
        category.topics = _.filter(category.topics, topic => !topic.noAccess ? topic : topic.noAccess.indexOf(this.org.parent_code) === -1); // eslint-disable-line no-undef

        return category;
      });
    },

    currentRouteName() {
      return this.$route.name;
    },

    title() {
      return 'Browse all topics';
    },

    sidebarImage() {
      if (this.topic.sidebarImage && this.topic.sidebarImage.fields) {
        const img = this.topic.sidebarImage.fields;

        return {
          title: img.title,
          url: img.file.url,
        };
      }
    },

    tree() {
      const map = {
        topicId: 'topic',
        articleId: 'article',
      };

      return _.map(this.$route.query, (value, key) => { // eslint-disable-line no-undef

        const item = {
          name: map[key],
          title: this.parseSlug(this.$route.params[map[key]]),
          query: {
            [key]: value,
          },
        };

        return item;
      });
    },
  },

  // Watchers
  watch: {
    categoriesToShow(categories) {
      if ( !categories || !categories.length ) return;
      this.saveActiveSection(this.categories[0].slug);
    },
  },

  // Methods
  methods: {
    ...mapActions('sidebar', ['saveActiveSection']),

    navigateTo({ name, query }) {
      if ( this.$route.name === name ) return;

      this.$router.push({
        name,
        query,
      });
    },

    scrollToSection(section) {
      this.$scrollTo(`#${section}`, 1000, { offset: -this.defaultOffset + 140 });
    },

    parseSlug(slug) {
      if ( !slug ) return 'Search';

      slug = slug.split('-').join(' ');
      return slug.charAt(0).toUpperCase() + slug.slice(1);
    },
  },

  // Lifecycles
  created() {
    if ( this.categoriesToShow && this.categoriesToShow.length ) this.saveActiveSection(this.categoriesToShow[0].slug);
  },
};
</script>



// WEBPACK FOOTER //
// ArticleSidebar.vue?ef86f1ac